import { render, staticRenderFns } from "./Requests.vue?vue&type=template&id=3f59fd60"
import script from "./Requests.vue?vue&type=script&setup=true&lang=js"
export * from "./Requests.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports